import SeoHelmet from '../../common/SeoHelmet';
import Header from '../../common/Header';
import Footer from '../../common/Footer';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

const ConsolidationTheory = () => {
  return (
    <>
      <SeoHelmet
        title="GeoCalc | Time Dependent Settlements of Shallow Foundations | Theory"
        description="Theory and formulation of primary consolidation settlement for shallow foundations, covering compressibility, stress increase, and time-dependent behavior."
        url="https://www.geocalc.app/consolidation-theory"
        image="https://www.geocalc.app/assets/og-theory-v1.jpg"
        schemaType="page"
        breadcrumbs={[
          { name: 'Home', url: 'https://www.geocalc.app/' },
          { name: 'Time Dependent Settlements | Theory', url: 'https://www.geocalc.app/consolidation-theory' },
        ]}
      />

      <Header />

      <div className="theory">
        <div className="theoryContainer">
          <h1>Time Dependent Settlements of Shallow Foundations | Theory & Formulations</h1>

          <h2>Formula:</h2>
          <p>
            The primary consolidation settlement S<sub>c</sub> is given by the formula:
          </p>
          <p>
            <strong>
              S<sub>c</sub> = H × m<sub>v</sub> × q<sub>z</sub>
            </strong>
          </p>

          <h2>Where:</h2>
          <ul>
            <li>
              <strong>
                S<sub>c</sub>
              </strong>{' '}
              = Primary consolidation settlement (m or mm)
            </li>
            <li>
              <strong>H</strong> = Thickness of the compressible soil layer (m)
            </li>
            <li>
              <strong>
                m<sub>v</sub>
              </strong>{' '}
              = Coefficient of volume compressibility (m²/kN)
            </li>
            <li>
              <strong>
                q<sub>z</sub>
              </strong>{' '}
              = Average stress increase due to the foundation load (kN/m²)
            </li>
          </ul>

          <h2>Explanation:</h2>
          <p>
            - The thickness of the compressible soil layer H is the depth of the soil that will compress under the foundation's
            load.
            <br />- The coefficient of volume compressibility m<sub>v</sub> quantifies how much the soil will compress per unit
            increase in stress. This value is often determined from consolidation tests.
            <br />- The average stress increase q<sub>z</sub> is the additional stress caused by the applied foundation load,
            typically calculated based on the foundation's size and load.
          </p>

          <h2>Quick Summary:</h2>
          <ul>
            <li>Primary consolidation is the slow drainage of water from clay layers under load, leading to settlement.</li>
            <li>The time rate of settlement depends on the soil properties and layer thickness.</li>
          </ul>
        </div>
        <div className="theoryButtonContainer">
          <Link to="/calculations/consolidation">
            <Button variant="outlined" size="small">
              GO TO CALCULATOR
            </Button>
          </Link>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ConsolidationTheory;
